<template>
  <div v-if="orderList.length > 0" class="record">
    <div class="record-item" v-for="order in orderList" :key="order.id">
      <div class="item-title">{{ getActiveText(order.activityCode) }}</div>
      <div class="item-name">{{ order?.productDTO.name }}</div>
      <div class="item-content">
        <div class="item-content__icon">
          <img :src="`${imgPrefix}${order?.productDTO.headerImgUrl}`" alt="" />
        </div>
        <div class="item-content__main">
          <div class="item-content__main-echange">
            兑换时间：{{ formateDate(order.orderTime) }}
          </div>
          <div class="item-content__main-effect">
            有效时间：{{ formateDate(order.expireTime) }}
          </div>
        </div>
        <div class="item-content__btn" @click="onRouteOrderDetail(order)">
          去查看
        </div>
      </div>
    </div>
  </div>
  <div v-else class="record-empty">
    <img class="order-empty__img" src="../../assets/order-empty.png" />
    <div class="order-empty__text">暂无兑换记录</div>
  </div>
</template>

<script>
import { onMounted, toRef, reactive } from 'vue'
import { Toast } from 'vant'
import api from '@/api'
import { useRouter } from 'vue-router'
import globalVariables from '@/utils/globalVariables'
import { formateDate } from '@/utils'

export default {
  setup() {
    const router = useRouter()
    const data = reactive({
      orderList: []
    })

    const getActiveText = code => {
      let text
      switch (code) {
        case 1001:
          text = '积分商城'
          break
        case 1002:
          text = '达标有礼'
          break
        case 1003:
          text = '周三惠客日'
          break
        case 1004:
          text = '“贷”客礼遇'
          break
        case 1006:
          text = '健康导诊'
          break
				case 1007:
					text = '放薪特权'
					break
        default:
          text = '未知'
      }
      return text
    }

    const onRouteOrderDetail = order => {
      router.push({
        path: '/orderDetail',
        query: {
          orderCode: order.orderCode
        }
      })
    }

    onMounted(() => {
      Toast.loading({
        message: '加载中...',
        forbidClick: true
      })
      api.getOrderList().then(res => {
        Toast.clear()
        data.orderList = res.data
      })
    })
    return {
      imgPrefix: globalVariables.imgPrefix,
      orderList: toRef(data, 'orderList'),
      getActiveText,
      formateDate,
      onRouteOrderDetail
    }
  }
}
</script>

<style lang="less" scoped>
.record {
  min-height: 100vh;
  background: #f5f5f5;
  overflow: hidden;
  .record-item {
    height: 131px;
    background: #ffffff;
    margin-top: 8px;
    padding-bottom: 11px;
    overflow: hidden;
    .item-title {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #333333;
      margin-top: 13px;
      margin-left: 14px;
    }
    .item-name {
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      margin-top: 11px;
      margin-left: 14px;
    }
    .item-content {
      display: flex;
      align-items: center;
      margin-top: 11px;
      .item-content__icon {
        width: 81px;
        height: 53px;
        margin-left: 15px;
        img {
          width: 81px;
          height: 53px;
        }
      }
      .item-content__main {
        margin-left: 14px;
        flex: 1;
        .item-content__main-echange {
          font-size: 10px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
        }
        .item-content__main-effect {
          font-size: 10px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #666666;
          margin-top: 12px;
        }
      }
      .item-content__btn {
        margin-right: 13px;

        width: 79px;
        height: 30px;
        background: #d80c18;
        border-radius: 15px;

        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ffffff;
      }
      .item-content__btn:active {
        opacity: 0.8;
      }
    }
  }
}
.record-empty {
  background-color: #ffffff;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .order-empty__img {
    margin-top: -80px;
    width: 300px;
    height: 190px;
  }
  .order-empty__text {
    margin-top: 27px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #999999;
  }
}
</style>